export const PATH = '/reports';
